var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33176 11.5075C7.17321 11.7428 6.82679 11.7428 6.66824 11.5075L1.35777 3.62346C1.17881 3.35777 1.36919 3 1.68953 3L12.3105 3C12.6308 3 12.8212 3.35777 12.6422 3.62346L7.33176 11.5075Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElDown);
export default __webpack_public_path__ + "static/media/el-down.6e3e250cfa8e09e1d9d626ab88893c39.svg";
export { ForwardRef as ReactComponent };